import React, { useState, useEffect, useMemo, useCallback} from "react";
import axios from "axios";
import Cookies from "js-cookie";
import UAParser from "ua-parser-js";
import { Navbar, Nav } from "react-bootstrap";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Comments from "./Comments";
import Logo1 from '../images/logo1.png'
import Logo2 from '../images/logo2.png'
import Testimonies from "./Testimonies";
import Contact from "./Contact";
import arrow from "../images/arrow.png";
import Footer from "./Footer";

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'


export default function Home() {
  const apiUrl =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_URL_DEV
    : process.env.REACT_APP_API_URL_PROD;
  const [menuIsClicked, setMenuIsClicked] = useState(false);
  const [openServiceExpand, setOpenServiceExpand] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const Create = "Create";
  const Design = "Design";
  const Deploy = "Deploy";
  const Manage = "Manage";

  const handleServiceClickOpen = (service) => {
    setModalContent(service);
    setOpenServiceExpand(true);
  };

  const handleServiceClicklose = () => {
    setOpenServiceExpand(false);
  };

  const MySwal = withReactContent(Swal)


  const [activeLink, setActiveLink] = useState("Home");
  const [rotated, setRotated] = useState(false);
  const [reverseRotated, setReverseRotated] = useState(false);
  const [theme, setTheme] = useState("dark");
  const [expandedCard, setExpandedCard] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [chatOpen, setChatOpen] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [likeCounts, setLikeCounts] = useState({});
  const [dislikeCounts, setDislikeCounts] = useState({});
  const [userLikes, setUserLikes] = useState({});


  
  

  const handleClick = () => {
    setRotated(true); // For example, you might start an animation
    setTimeout(() => {
      setRotated(false); // After a short delay, stop the animation
      setReverseRotated(true); // Start another animation
      setTimeout(() => {
        setReverseRotated(false); // After another short delay, stop the second animation
        const newTheme = toggleTheme(); // Finally, toggle the theme and get the new theme
        saveThemeToLocalStorage(newTheme); // Save the new theme to local storage
      }, 100);
    }, 100);
  };
  
  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    return newTheme;
  };
  
  const saveThemeToLocalStorage = (theme) => {
    localStorage.setItem("theme", theme); // Save the theme to local storage
  };


    useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    if (!storedTheme) {
      setTheme("dark");
    }else if(storedTheme && storedTheme === "light"){
      setTheme("light");
    }else if(storedTheme && storedTheme === "dark"){
      setTheme("dark");
    }
      
  }, []);

  useEffect(() => {
      if(theme === "device"){
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
          const newColorScheme = event.matches ? "dark" : "light";
          setTheme(newColorScheme);
          console.log("newColorScheme:", newColorScheme)
       });
      }
   })

  
  const handleThemeChange = (selectedTheme) => {
    if (selectedTheme === "device") {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setTheme(prefersDark ? "dark" : "light");
      setTheme("device");
      localStorage.setItem("theme", selectedTheme);
    } else {
      setTheme(selectedTheme);
      localStorage.setItem("theme", selectedTheme);
    }
  };
  
 

  const handleScroll = () => {
    const sections = ["Home", "Services", "Projects", "About"];
    const scrollPos = window.scrollY + window.innerHeight / 2; // Center of the viewport
    let currentSection = "";

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        const offsetTop = element.offsetTop;
        const offsetHeight = element.offsetHeight;

        if (scrollPos >= offsetTop && scrollPos < offsetTop + offsetHeight) {
          currentSection = section;
        }
      }
    });

    setActiveLink(currentSection || "Home");
  };

  // Debounce the scroll event handler
  const debounce = (func, wait) => {
    let timeout;
    return () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func();
      }, wait);
    };
  };

  useEffect(() => {
    const debouncedHandleScroll = debounce(handleScroll, 50);
    window.addEventListener("scroll", debouncedHandleScroll);
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
    };
  }, []);
  

  const handleExpand = (index) => {
    setExpandedCard(index);
  };


  const handleOpenProjectMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseProjectMenu = () => {
    setAnchorEl(null);
  };


  const handleOpenChat = (projectId) => {
    setSelectedProjectId(projectId); // Set the projectId when chat is opened
    setChatOpen((prevState) => !prevState);
    console.log(projectId)
  };






  const projects = useMemo(() => [
    { id: 'Delivery Website', name: 'Delivery Website', tools: ["PHP", "MYSQL", "verpex Host"], description: 'A delivery website made with React for the front end and node express for the backend and MYSQL database. ', link: "https://estuch-shipment.netlify.app/"  },

    { id: 'School Website', name: 'School Website', tools: ["React", "MongoDb", "verpex Host"], description: 'This website allow teachers to upload exam and allow students to take exam and display result in seconds.', link: "https://merit-exam.netlify.app/" },

    { id: 'Fintech Website', name: 'Fintech Website', tools: ["React", "MYSQL", "Netlify"], description: 'This website is a bank website that allow users to transfer, and receive funds from customers of the same bank.', link: "https://trustlink.netlify.app/" },

    { id: 'Landing Page', name: 'Landing Page', tools: ["HTML, CSS", "MYSQL", "Netlify"], description: 'This is just an investment landing page platform.', link: "https://estuchinvestmentwebsite1.netlify.app/"  },
  ], []);

  const getProjectClass = (name) => {
    const projectClasses = {
      "Delivery Website": "delivery",
      "School Website": "school",
      "Fintech Website": "fintech",
      "Landing Page": "landing"
    };
    return projectClasses[name] || "";
  };



  useEffect(() => {
    projects.forEach((project) => {
      axios.get(`${apiUrl}/likes?project_id=${project.id}`)
        .then((response) => {
          setLikeCounts((prev) => ({ ...prev, [project.id]: response.data.likeCount }));
          setDislikeCounts((prev) => ({ ...prev, [project.id]: response.data.dislikeCount }));
        })
        .catch((error) => {
          console.error(`Error fetching like/dislike counts for project ${project.id}:`, error);
        });
    });

    const userId = Cookies.get('user_id');
    if (userId) {
      axios.get(`${apiUrl}/user-likes?user_id=${userId}`)
        .then((response) => {
          setUserLikes(response.data.likes);
        })
        .catch((error) => {
          console.error('Error fetching user likes:', error);
        });
    }
  }, [apiUrl, projects]);



  const handleLikeDislike = (projectId, liked) => {
    let userId = Cookies.get('user_id');
    if (!userId) {
      const parser = new UAParser();
      const uaResult = parser.getResult();
      const deviceInfo = `${uaResult.browser.name}-${uaResult.os.name}-${uaResult.device.type || 'desktop'}`;
      userId = `${deviceInfo}-${new Date().getTime()}`;
      Cookies.set('user_id', userId, { expires: 365 });
    }
  
    axios.post(`${apiUrl}/like`, { user_id: userId, project_id: projectId, liked })
      .then(() => {
        axios.get(`${apiUrl}/likes?project_id=${projectId}`)
          .then((response) => {
            setLikeCounts((prev) => ({ ...prev, [projectId]: response.data.likeCount }));
            setDislikeCounts((prev) => ({ ...prev, [projectId]: response.data.dislikeCount }));
          })
          .catch((error) => {
            console.error(`Error fetching updated like/dislike counts for project ${projectId}:`, error);
          });
  
        // Update userLikes state and set cookies
        setUserLikes((prev) => {
          const updatedUserLikes = { ...prev, [projectId]: liked };
          Cookies.set('user_likes', JSON.stringify(updatedUserLikes), { expires: 365 });
          return updatedUserLikes;
        });
      })
      .catch((error) => {
        console.error(`Error updating like/dislike status for project ${projectId}:`, error);
      });
  };
  


  const downloadCv = async () => {
    Swal.fire({
      title: `<p className="text-danger">Do you want download this cv?</p>`,
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Download",
      confirmButtonColor: "#0077ff",
      cancelButtonColor: `red`
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const fileName = 'PromiseUcheCv.pdf';
        const link = document.createElement('a');
        link.href = `${apiUrl}/download-pdf?fileName=${fileName}`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  }



  return (
    <div data-theme={theme} className="app" id="Home">
      <Navbar
        expand="lg"
        className={`navbar shadow-sm ${menuIsClicked ? "navbarIsOpen shadow-lg rounded-bottom-3" : ""}`}
        id="navbar"
      >
        <div className="menuAndTheme">
          <Navbar.Brand href="#" className="navbar-brand">
            {theme === "dark" ? <img src={Logo2} alt="Your Logo" /> : <img src={Logo1} alt="Your Logo" />}
          </Navbar.Brand>
          <div className="d-flex justify-content-around theme">
          <div className="m-auto" onClick={handleClick} style={{ cursor: "pointer" }}>
              <span className={`material-symbols-outlined mt-1 ${rotated ? "rotate" : ""} ${reverseRotated ? "reverse-rotate" : ""}`}>
                {theme === "dark" ? 'brightness_4' : 'light_mode'}
              </span>
            </div>
            <Navbar.Toggle className="navbar-toggler" aria-controls="navbarNav" onClick={() => setMenuIsClicked((prevState) => !prevState)}>
              {!menuIsClicked ? (
                <span className="menuIcon bi bi-list"></span>
              ) : (
                <span className="menuIcon bi bi-x text-danger"></span>
              )}
            </Navbar.Toggle>
          </div>
        </div>
        <Navbar.Collapse className="nav-items" id="navbarNav">
          <div className="p-5">
            <div className="socials-wrapper">
              <div className="socials">
                <span className="bi bi-whatsapp"></span>
                <span className="bi bi-facebook"></span>
                <span className="bi bi-telegram"></span>
                <span className="bi bi-github"></span>
                <span className="bi bi-linkedin"></span>
              </div>
              <div className="line"></div>
            </div>
            <Nav className="w-100">
            {["Home", "Services", "Projects", "About"].map((section) => (
              <Nav.Link
                href={`#${section}`}
                className={`nav-link ${activeLink === section ? "active" : ""}`}
                key={section}
              >
                {section}
              </Nav.Link>
            ))}
            </Nav>
            <div className="py-4 hireMe">
              <Button className="hireMeBtn w-100 rounded-1 shadow-lg" onClick={downloadCv}>my resume</Button>
            </div>

          </div>
        </Navbar.Collapse>
      </Navbar>




      
      <div className="pt-5 hero ">
        <div className="row p-4 pt-5">
         
              <div className="col-12 col-md-6 ">
              <h3 className={theme === "dark" ? "dark" : "light"}>My Name is Promise </h3><span className="uche">Uche..</span>
          <h5>I make great websites that your users will love!</h5>
          <p className="pt-3">
            I'm an experienced full stack developer with a strong portfolio of successful projects. I possess expertise in different areas of programing and frontend technologies to bring your website or application to life with a modern, user-friendly interface.
          </p>
              </div>

          <div className="col-12 col-md-6 py-4 mt-lg-5 hireMe">
              <Button className="hireMeBtn w-100 rounded-1 shadow-lg">Hire Me</Button>
            </div>
        </div>
      </div>





      <div className="services-wrapper pb-5 " id="Services">
        <div className="services p-2">

          <div className="container m-auto row g-3">
          <h3 className="pb-4 px-4">Services</h3>

          <div className=" col-12 col-md-6">
            <div className="services-items">
            <h5>
              Create
              <i className="bi bi-exclamation-circle" onClick={() => handleServiceClickOpen(Create)}></i>
            </h5>
            <p>I create innovative websites that captivate your audience and stand out in a crowded competitive online space.</p>
            <div className="icon">
              <i className="bi bi-layers-fill"></i>
            </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="services-items">
            <h5>
              Design
              <i className="bi bi-exclamation-circle" onClick={() => handleServiceClickOpen(Design)}></i>
            </h5>
            <p>My designs are visually appealing, user-friendly, modern, functional, and aesthetically pleasing.</p>
            <div className="icon">
              <i className="bi bi-palette2"></i>
            </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="services-items">
            <h5>
              Deploy
              <i className="bi bi-exclamation-circle" onClick={() => handleServiceClickOpen(Deploy)}></i>
            </h5>
            <p>Reliable website deployment and steady monitoring to ensure 24/7 uptime: we make sure that our websites run smoothly and consistently.</p>
            <div className="icon">
              <i className="bi bi-database-fill"></i>
            </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="services-items">
            <h5>
              Manage
              <i className="bi bi-exclamation-circle" onClick={() => handleServiceClickOpen(Manage)}></i>
            </h5>
            <p>Website management to ensure optimal performance by making sure that your site remains in top condition over time.</p>
            <div className="icon">
              <i className="bi bi-person-wheelchair"></i>
            </div>
          </div>
            </div>
          </div>

        </div>
        <Dialog
          open={openServiceExpand}
          className="serviceExpand"
          keepMounted
          onClose={handleServiceClicklose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent className="content">
            <DialogContentText id="alert-dialog-slide-description">
              <h4>{modalContent}</h4>
              <hr />
              {modalContent === "Create" && (
                <p>
                  With <b>HTML, CSS, JS, REACT, PHP, MYSQL, MONGODB, JQUERY,</b> etc, I create innovative and engaging websites from start to finish, whether dynamic or static websites.
                </p>
              )}
              {modalContent === "Design" && (
                <p>
                  I make use of modern technologies like bootstrap, material designs, svg and vector icons to design visually stunning and user-friendly interfaces.
                </p>
              )}
              {modalContent === "Deploy" && (
                <p>
                  I use reliable services like GoDaddy, Verpex, Hostgator, etc to provide a one-click deployment of websites and web applications, ensuring smooth and consistent uptime.
                </p>
              )}
              {modalContent === "Manage" && (
                <p>
                  I'm responsible for managing and monitoring websites, ensuring they remain up-to-date and perform optimally over time.
                </p>
              )}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>



      <div className="container projects pt-5" id="Projects">
        <h3 className="pb-3">Projects</h3>
        <div className="row">
          {projects.map((project, index) => (
            <div key={project.id} className="col-md-6 mb-3">
              <div className={`card${index === expandedCard ? " expanded" : "unexpanded"}`} onClick={() => handleExpand(index)}>
                <div className="">
                  {index === expandedCard ? (
                    <div className="">
                      <div className="p-4">
                        <h5>{project.name}</h5>
                        <p>{project.description}</p>
                        <div className="text-primary fw-bold">
                          <span>{project.tools.map((tool, index) => 
                            <span key={index} className="tools me-3">
                              {tool}
                            </span>
                          )}</span>
                        </div>
                        <div className="mt-3 d-flex justify-content-between border rounded-5 p-2">
                          <div className="my-auto ms-3">
                            <span className="bi bi-github"></span>
                            <a className="text-body" href={project.link}><span className="bi bi-box-arrow-up-right ms-3"></span></a>
                          </div>
                          <div className="me-3">
                            <span className="">
                            <button
                                className="btn bi bi-three-dots-vertical"
                                id="basic-button"
                                aria-controls={open ? "basic-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                onClick={handleOpenProjectMenu}
                              ></button>
                              <div className="position-absolute">
                                <Menu
                                  id="basic-menu"
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleCloseProjectMenu}
                                  MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                  }}
                                >
                                  <MenuItem onClick={handleCloseProjectMenu}>Declare interest</MenuItem>
                                  <MenuItem onClick={handleCloseProjectMenu}>Buy script</MenuItem>
                                  <MenuItem onClick={handleCloseProjectMenu}>Fork project</MenuItem>
                                </Menu>
                              </div>
                            </span>


                            <span className="btn bi bi-chat-left-dots p-2" onClick={() => handleOpenChat(project.id)}></span>

                            
                            <span
                        className={`btn bi ${userLikes[project.id] === true ? 'bi-hand-thumbs-up-fill text-success' : 'bi-hand-thumbs-up'}`}
                        onClick={() => handleLikeDislike(project.id, true)}
                      >{likeCounts[project.id] || 0}</span>

                      <span
                        className={`btn bi ${userLikes[project.id] === false ? 'bi-hand-thumbs-down-fill text-danger' : 'bi-hand-thumbs-down'}`}
                        onClick={() => handleLikeDislike(project.id, false)}
                      >{dislikeCounts[project.id] || 0}</span>
                 



                          </div>
                        </div>
                        <div>
                          {chatOpen && selectedProjectId === project.id && (
                            <div className="mt-4">
                              <div>
                                <Comments projectId={project.id} projectName={project.name} />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    
                      <div className={`rounded p-3 project-name-show ${getProjectClass(project.name)}`}>
                        <b>{project.name}</b>
                      </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>




      <div className="mt-2 arrrow">
        <Button variant="outlined" color="warning">see more projects</Button>
          <img className="arrow" src={arrow} alt="" style={{
            
          }}/>
          <div className=" pb-md-5">
            <div className="row g-2">

              <div className="col-12 col-md-6">
                <Testimonies />
              </div>

              <div className="col-12 col-md-6">
                <Contact/>
              </div>

            </div>
          </div>
      </div>
      </div>

      <Footer handleThemeChange={handleThemeChange} />
  
      </div>
  );
}
